import React from 'react';

import { Spinner } from 'castlecraft-ui';

const InfobookLoader = ({ searchString }) =>
  searchString?.length > 0 &&
  searchString.length < 2 && (
    <div style={{ margin: '40px', display: 'flex', justifyContent: 'center' }}>
      <Spinner size="lg" />
    </div>
  );

export default InfobookLoader;
